/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


export let MDColorUtil = function() {

	function sRGB2Lab( xr, xg, xb ) {
		// Observer=2°, Illuminant=D65
		var r=xr/255, g=xg/255, b=xb/255, x,y,z;
		// RGB -> XYZ (http://www.easyrgb.com/index.php?X=MATH&H=02#text2)
		r = r>0.04045 ? Math.pow((r+0.055)/1.055,2.4) : r / 12.92;
		g = g>0.04045 ? Math.pow((g+0.055)/1.055,2.4) : g / 12.92;
		b = b>0.04045 ? Math.pow((b+0.055)/1.055,2.4) : b / 12.92;
		x = (r*0.4124 + g*0.3576 + b*0.1805) / 0.95047;
		y = (r*0.2126 + g*0.7152 + b*0.0722) / 1.00000;
		z = (r*0.0193 + g*0.1192 + b*0.9505) / 1.08883;
		// XYZ -> CIE L*ab (http://www.easyrgb.com/index.php?X=MATH&H=07#text7)
		x = x>0.008856 ? Math.pow(x,1/3) : (7.787*x) + 16/116;
		y = y>0.008856 ? Math.pow(y,1/3) : (7.787*y) + 16/116;
		z = z>0.008856 ? Math.pow(z,1/3) : (7.787*z) + 16/116;
		return [ 116*y-16, 500*(x-y), 200*(y-z) ];
	}


	function deltaE_CIE76_sq( labA, labB ) {
		var deltaL = labA[0]-labB[0],
			deltaA = labA[1]-labB[1],
			deltaB = labA[2]-labB[2];
		return deltaL*deltaL + deltaA*deltaA + deltaB*deltaB;
	}

	/*unused..
	function deltaE_CIE76( labA, labB ) {
		var i = deltaE_CIE76_sq(labA,labB);
		return i<0 ? 0 : Math.sqrt(i);
	}*/


	function deltaE_CIE94_sq( labA, labB ) {
		// Observer=2°, Illuminant=D65
		// see http://www.easyrgb.com/index.php?X=DELT&H=04#text4
		// see https://github.com/THEjoezack/ColorMine/blob/master/ColorMine/ColorSpaces/Comparisons/Cie94Comparison.cs
		var deltaL = labA[0]-labB[0],
			deltaA = labA[1]-labB[1],
			deltaB = labA[2]-labB[2],
			c1 = Math.sqrt(labA[1]*labA[1]+labA[2]*labA[2]),
			c2 = Math.sqrt(labB[1]*labB[1]+labB[2]*labB[2]),
			deltaC = c1-c2,
			deltaC_sq = deltaC*deltaC,
			deltaH_sq = deltaA*deltaA + deltaB*deltaB - deltaC_sq,
			sc = 1.0 + 0.045*c1,
			sh = 1.0 + 0.015*c1;
		return deltaL*deltaL + deltaC_sq/(sc*sc) + deltaH_sq/(sh*sh);
	}

	/*unused..
	function deltaE_CIE94( labA, labB ) {
		var i = deltaE_CIE94_sq(labA,labB);
		return i<0 ? 0 : Math.sqrt(i);
	}*/



	// manhattan distance
	function dist_RGB0( r1,g1,b1, r2,g2,b2 ) {
		return ( Math.abs(r1-r2) + Math.abs(g1-g2) + Math.abs(b1-b2) ) / 3;
	}

	// euclidian distance
	function dist_RGB1_sq( r1,g1,b1, r2,g2,b2 ) {
		var dR = r1-r2,
			dG = g1-g2,
			dB = b1-b2;
		return ( dR*dR + dG*dG + dB*dB ) / 3;
	}

	// weighted euclidian distance: 3xR 4xG 2xB
	function dist_RGB2_sq( r1,g1,b1, r2,g2,b2 ) {
		var dR = r1-r2,
			dG = g1-g2,
			dB = b1-b2;
		return ( 3*dR*dR + 4*dG*dG + 2*dB*dB ) / 9;
	}

	// weighted euclidian distance, with varying weights that depend on "red" component
	// ..from http://www.compuphase.com/cmetric.htm
	function dist_RGB3_sq( r1,g1,b1, r2,g2,b2 ) {
		var rmean = (r1+r2) / 2,
			dR = r1-r2,
			dG = g1-g2,
			dB = b1-b2;
		return ( ( ((512+rmean)*dR*dR)/256 ) + 4*dG*dG + ( ((767-rmean)*dB*dB)/256 ) ) / (2.5+4+2.5);
	}


	function css_rgb2hex(rgb) {
		if( rgb.match(/^#[0-9A-Fa-f]{6}$/) ) return rgb;
		var rgbv = /rgb\((.+),(.+),(.+)\)/i.exec(rgb);
		if( !rgbv ) return rgb;
		var r=parseInt(rgbv[1]), g=parseInt(rgbv[2]), b=parseInt(rgbv[3]), pad=function(v) {
			return (v.length<2?'0':'')+v;
		};
		return '#'+pad(r.toString(16))+pad(g.toString(16))+pad(b.toString(16));
	}


	return {
		sRGB2Lab: sRGB2Lab,

		deltaE_CIE76_sq: deltaE_CIE76_sq,
		deltaE_CIE94_sq: deltaE_CIE94_sq,

		dist_RGB0: dist_RGB0,
		dist_RGB1_sq: dist_RGB1_sq,
		dist_RGB2_sq: dist_RGB2_sq,
		dist_RGB3_sq: dist_RGB3_sq,

		css_rgb2hex: css_rgb2hex,
	};

}(); // namespace MDColorUtil

